import request from '@/libs/http/index'
// 执行预约记录
export const executionPage = (params: any) => {
  return request.get({
    url: `/clinic/treatment-registration/es-page`,
    params,
  })
}
// 执行预约详情
export const executionDetail = (params: any) => {
  return request.get({
    url: `/clinic/execution/get`,
    params,
  })
}
// 左侧医疗记录
export const medicalRecordsLeftColumn = (params: any) => {
  return request.get({
    url: `/clinic/medical-records/left-column`,
    params,
  })
}
// 左侧医疗详情
export const medicalRecordsLeftDetail = (params: any) => {
  return request.get({
    url: `/clinic/medical-records/get-physio`,
    params,
  })
}
// 执行开单
export const executionOpen = (data: any) => {
  return request.post({
    url: `/clinic/medical-records/open-execution`,
    data,
  })
}
// 执行预约开单
export const treatmentExecutionOpen = (data: any) => {
  return request.post({
    url: `/clinic/execution/treatment-open-execution`,
    data,
  })
}
// 项目执行
export const executionRecordCreate = (data: any) => {
  return request.post({
    url: `/clinic/execution-record/create`,
    data,
  })
}
// 执行历史
export const executionHistoryPage = (params: any) => {
  return request.get({
    url: `/clinic/execution-history/page`,
    params,
  })
}
// 删除执行项目
export const deleteExecutionItem = (data: any) => {
  return request.delete({
    url: `/clinic/execution-record/delete`,
    params: data,
  })
}
// 左侧数据数量
export const medicalRecordsLeftCount = (params: any) => {
  return request.get({
    url: `/clinic/medical-records/es-count`,
    params,
  })
}
// 左侧数据数量
export const executionEsCount = (params: any) => {
  return request.get({
    url: `/clinic/execution/es-count`,
    params,
  })
}
